import React, { useState, useEffect } from "react";
import { usd, ROLES } from "./ui";
import { fetchInsights } from "../api";
import "./Dashboard.css";

export default function Weekly({ data, ctx }) {
  const { weeks } = data;
  const [metric, setMetric] = useState("revenue");
  const [role, setRole] = useState("all");
  const [insights, setInsights] = useState(null);
  const [insightErr, setInsightErr] = useState(null);

  useEffect(() => {
    setInsights(null); setInsightErr(null);
    fetchInsights(ctx).then(setInsights).catch((e) => setInsightErr(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.lastUpdated]);

  const valueOf = (w) => {
    if (metric === "revenue") return role === "all" ? w.revenue : (w.revByRole?.[role] || 0);
    return role === "all" ? (w.hours.CNA + w.hours.LPN + w.hours.RN) : (w.hours[role] || 0);
  };
  const fmt = (v) => (metric === "revenue" ? usd(v) : Math.round(v).toLocaleString() + " h");
  const max = Math.max(1, ...weeks.map(valueOf));
  const total = weeks.reduce((s, w) => s + valueOf(w), 0);

  return (
    <div className="dash">
      <section className="panel">
        <div className="panel-head">
          <h2>Weekly {metric === "revenue" ? "Revenue" : "Hours"}{role !== "all" ? ` — ${role}` : ""}</h2>
          <div className="toggle-group">
            <div className="toggle">
              <button className={metric === "revenue" ? "on" : ""} onClick={() => setMetric("revenue")}>Revenue</button>
              <button className={metric === "hours" ? "on" : ""} onClick={() => setMetric("hours")}>Hours</button>
            </div>
            <div className="toggle">
              <button className={role === "all" ? "on" : ""} onClick={() => setRole("all")}>All</button>
              {ROLES.map((r) => <button key={r} className={role === r ? "on" : ""} onClick={() => setRole(r)}>{r}</button>)}
            </div>
          </div>
        </div>
        <div className="weeks">
          {weeks.map((w) => (
            <div key={w.ws} className="week">
              <div className="week-bar-wrap"><div className="week-bar" style={{ height: Math.max(4, (valueOf(w) / max) * 140) + "px" }} /></div>
              <div className="week-val">{fmt(valueOf(w))}</div>
              <div className="week-label">{w.ws.slice(5)}</div>
            </div>
          ))}
        </div>
        <div className="week-total">Total: <strong>{fmt(total)}</strong> across {weeks.length} weeks</div>
      </section>

      {/* Weekly Insights */}
      <section className="panel">
        <div className="panel-head">
          <h2>Weekly Insights</h2>
          {insights && <span>{insights.source === "ai" ? "AI generated" : "computed"}</span>}
        </div>
        {!insights && !insightErr && <div className="state">Analyzing…</div>}
        {insightErr && <div className="state error">Insights unavailable: {insightErr}</div>}
        {insights && (
          <ul className="insights-list">
            {insights.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        )}
      </section>

      <section className="panel">
        <div className="panel-head"><h2>Weekly detail</h2></div>
        <table className="grid">
          <thead><tr><th>Week starting</th><th>Shifts</th><th>Revenue</th><th>CNA</th><th>LPN</th><th>RN</th></tr></thead>
          <tbody>
            {weeks.map((w) => (
              <tr key={w.ws}>
                <td className="rowhead">{w.ws}</td>
                <td>{w.shiftCount}</td>
                <td className="strong">{usd(w.revenue)}</td>
                {ROLES.map((r) => <td key={r}>{usd(w.revByRole?.[r] || 0)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
